import { ExternalLink, Gift, Star, TrendingUp } from 'lucide-react';

const Offers = () => {
  const offers = [
    {
      id: 1,
      name: 'Betclic',
      url: 'https://www.betclic.fr/',
      bonus: 'Bonus de bienvenue jusqu\'à 100€',
      icon: <Star className="w-8 h-8" />,
      description: 'L\'un des leaders du marché français avec une interface intuitive et des cotes compétitives. Pariez sur le sport et les courses hippiques avec confiance.',
      color: 'from-blue-500 to-blue-700',
    },
    {
      id: 2,
      name: 'Olybet',
      url: 'https://olybet.fr/',
      bonus: 'Bonus de bienvenue de 100€',
      icon: <TrendingUp className="w-8 h-8" />,
      description: 'Plateforme moderne offrant une expérience de paris fluide et des promotions régulières. Idéal pour les parieurs recherchant innovation et performance.',
      color: 'from-purple-500 to-purple-700',
    },
    {
      id: 3,
      name: 'Genybet',
      url: 'https://www.genybet.fr/',
      bonus: 'Bonus de bienvenue de 200€ + 50€ de paris gratuits',
      icon: <Gift className="w-8 h-8" />,
      description: 'Spécialiste des paris hippiques avec un bonus généreux et des outils d\'analyse avancés. La référence pour les amateurs de turf et de sport.',
      color: 'from-green-500 to-green-700',
    },
  ];

  return (
    <section id="offres" className="py-20 bg-dark-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Offres <span className="text-toxic-green">Exclusives</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Sélection rigoureuse des meilleures plateformes de paris en France. Chaque offre a été vérifiée pour vous garantir sécurité et avantages réels.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {offers.map((offer, index) => (
            <div
              key={offer.id}
              itemScope
              itemType="http://schema.org/Product"
              className={`relative bg-dark-bg border-2 border-gray-800 rounded-2xl p-8 hover:border-toxic-green transition-all duration-300 transform hover:scale-105 ${
                index === 2 ? 'md:col-span-1' : ''
              }`}
            >
              {/* Hexagonal accent */}
              <div className="absolute top-4 right-4 w-16 h-16 border border-toxic-green opacity-20 rotate-45"></div>
              
              {/* Placeholder for logo */}
              <div className="mb-6 h-16 flex items-center justify-center">
                <div className={`w-16 h-16 rounded-lg bg-gradient-to-br ${offer.color} flex items-center justify-center text-white`}>
                  {offer.icon}
                </div>
              </div>

              <h3 className="text-2xl font-bold mb-3 text-white" itemProp="name">{offer.name}</h3>
              
              <div className="mb-4 p-4 bg-toxic-green/10 border border-toxic-green/30 rounded-lg">
                <p className="text-toxic-green font-semibold text-lg" itemProp="offers" itemScope itemType="http://schema.org/Offer">
                  <span itemProp="description">{offer.bonus}</span>
                </p>
              </div>

              <p className="text-gray-400 mb-6 leading-relaxed" itemProp="description">{offer.description}</p>

              <a
                href={offer.url}
                target="_blank"
                rel="noopener noreferrer nofollow sponsored"
                itemProp="url"
                className="inline-flex items-center justify-center w-full px-6 py-3 bg-toxic-green text-dark-bg font-bold rounded-lg hover:bg-opacity-80 transition-all group"
              >
                Jogue no {offer.name}
                <ExternalLink className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offers;

